module.exports = ".alert-dialog {\n  min-width: 300px; }\n"